import { IMenuItem } from './interfaces';
import { PermissionsType } from '../';

export const MENU_LIST: IMenuItem[] = [
  {
    label: 'wfmModule.titles.slotView',
    route: '/slots-view',
    permissionCode: PermissionsType.slotsView,
  },
  {
    label: 'wfmModule.typeEmployees.operator',
    route: '/operator',
    permissionCode: PermissionsType.operator,
  },
  {
    label: 'wfmModule.typeEmployees.methodist',
    route: '/methodist',
    permissionCode: PermissionsType.methodist,
  },
  {
    label: 'wfmModule.titles.methodistCalendar',
    route: '/methodists/methodist/calendar',
    exact: true,
    permissionCode: PermissionsType.methodistActivityApprove,
  },
  {
    label: 'wfmModule.titles.methodistManagerCalendar',
    route: '/methodists/manager/calendar',
    exact: true,
    permissionCode: PermissionsType.methodistManagerCalendar,
  },
  {
    label: 'wfmModule.titles.logs',
    route: '',
    items: [
      {
        label: 'wfmModule.titles.logActions',
        route: '/action-log',
        permissionCode: PermissionsType.actionLogList,
      },
      {
        label: 'wfmModule.titles.logManagement',
        route: '/methodist-management-log',
        permissionCode: PermissionsType.methodistLogList,
      },
    ],
  },
  {
    label: 'wfmModule.typeEmployees.manyMethodist',
    route: '/methodists/list',
    exact: true,
    permissionCode: PermissionsType.methodistList,
  },
  {
    label: 'wfmModule.typeEmployees.arbitration',
    route: '/showcase-stk',
    exact: true,
    permissionCode: PermissionsType.showcaseStkList,
  },
  {
    label: 'wfmModule.titles.selfbooking',
    route: '',
    items: [
      {
        label: 'wfmModule.titles.disconnectionCountry',
        route: '/selfbooking/countries',
        permissionCode: PermissionsType.selfbookingList,
      },
      {
        label: 'wfmModule.titles.disableLocales',
        route: '/selfbooking/locales',
        permissionCode: PermissionsType.selfbookingList,
      },
    ],
  },
  {
    label: 'wfmModule.titles.setting',
    route: '',
    items: [
      {
        label: 'wfmModule.titles.ageCategories',
        route: '/gradation',
        permissionCode: PermissionsType.gradationList,
      },
      {
        label: 'wfmModule.titles.liFormats',
        route: '/intro-lesson-format',
        permissionCode: PermissionsType.introLessonFormatList,
      },
      {
        label: 'wfmModule.titles.knowledgeLevels',
        route: '/proficiency',
        permissionCode: PermissionsType.proficiencyList,
      },
      {
        label: 'wfmModule.titles.subjects',
        route: '/subject',
        permissionCode: PermissionsType.subjectList,
      },
      {
        label: 'wfmModule.titles.visitPromptStrategy',
        route: '/visit-prompt-strategy',
        permissionCode: PermissionsType.visitPromptStrategyList,
      },
      {
        label: 'wfmModule.titles.manyProducts',
        route: '/product',
        permissionCode: PermissionsType.productList,
        exact: true,
      },
      {
        label: 'wfmModule.titles.productGroups',
        route: '/product/group',
        permissionCode: 'product_list',
        exact: true,
      },
      {
        label: 'wfmModule.titles.manyServiceLanguage',
        route: '/service-language',
        permissionCode: 'service_language_list',
        exact: true,
      },
      {
        label: 'wfmModule.titles.slotGrids',
        route: '/slots-schedule',
        permissionCode: PermissionsType.slotScheduleList,
      },
      {
        label: 'wfmModule.titles.manyMode',
        route: '/modes',
        permissionCode: PermissionsType.modeList,
      },
      {
        label: 'wfmModule.titles.typesMethodists',
        route: '/methodists-types',
        permissionCode: PermissionsType.methodistKindList,
      },
      {
        label: 'wfmModule.titles.methodistGroups',
        route: '/methodists-groups',
        permissionCode: PermissionsType.methodistGroupList,
      },
      {
        label: 'wfmModule.titles.distributionStrategies',
        route: '/methodist-distribution-strategies',
        permissionCode: PermissionsType.methodistKindList,
      },
      {
        label: 'wfmModule.entities.manyTag',
        route: '/tags',
        permissionCode: PermissionsType.tagList,
      },
      {
        label: 'wfmModule.entities.instruction',
        route: '/instruction',
        permissionCode: PermissionsType.instructionList,
      },
      {
        label: 'wfmModule.titles.permissions',
        route: '/permissions',
        permissionCode: PermissionsType.permissionList,
      },
      {
        label: 'wfmModule.titles.reportTemplates',
        route: '/reports-templates',
        permissionCode: PermissionsType.reportTemplateList,
      },
      {
        label: 'wfmModule.titles.methodistsForecasts',
        route: '/forecast',
        permissionCode: PermissionsType.forecastList,
      },
      {
        label: 'wfmModule.titles.operatorsForecasts',
        route: '/operator-forecast',
        permissionCode: PermissionsType.operatorForecastList,
      },
      {
        label: 'wfmModule.titles.globalVariables',
        route: '/global-variables',
        permissionCode: PermissionsType.globalVariablesList,
      },
    ],
  },
];

export const NOTIFICATION_PARAMS = {
  success: {
    backgroundColor: '#B9FDBF',
    backgroundHoverColor: '#B9FDBF',
    color: '#062108',
    fontFamily: 'StratosSkyeng, Open Sans, Arial, sans-serif',
  },
  error: {
    backgroundColor: '#FFEBED',
    backgroundHoverColor: '#FFEBED',
    color: '#2E0509',
    fontFamily: 'StratosSkyeng, Open Sans, Arial, sans-serif',
  },
};
